export enum UserRole {
  admin = 'admin',
  assistant = 'assistant',
  transport_manager = 'transport_manager',
  customer_manager = 'customer_manager',
  storekeeper = 'storekeeper',
  accountant = 'accountant',
  guest = 'guest',
  mechanic = 'mechanic',
}
